import { makeStyles } from "@material-ui/core/styles";
import { Field, FieldProps, Form, Formik } from "formik";
import { FormikHelpers } from "formik/dist/types";
import { MessageThread } from "interfaces/front/business";
import { ValidationErrorV2 } from "lib/service/BaseClientService";
import { ContactMessage, FrontMessageService, OrderMessage, PostOrderMessageQuery } from "lib/service/client/FrontMessageService";
import { infoToast } from "lib/toast";
import { useRouter } from "next/router";
import React, { FC } from "react";
import { object, string } from "yup";
import styled from "styled-components";

export const PostOrderMessageForm: FC<{
  messageThread: MessageThread;
  onSuccess: (message: ContactMessage) => void;
}> = (props) => {
  const router = useRouter();
  const classes = useStyles();
  return (
    <Formik<PostOrderMessageFields>
      initialValues={{
        message: "",
      }}
      validationSchema={object().shape({
        message: string().trim().required("必須項目です").max(2000, "2000文字以下にしてください"),
      })}
      onSubmit={async (values: PostOrderMessageFields, helpers: FormikHelpers<PostOrderMessageFields>): Promise<void> => {
        const setValidationError = (validationError: ValidationErrorV2): void => {
          helpers.setErrors(validationError);
        };
        const service = new FrontMessageService();
        const query = { order_message_thread_id: props.messageThread.id, message: values.message };
        await service.postOrderMessage(query, router, setValidationError, (orderMessage: OrderMessage) => {
          helpers.resetForm();
          infoToast("メッセージを投稿しました。");
          props.onSuccess(orderMessage);
        });
        helpers.setSubmitting(false);
      }}
    >
      {({ errors, touched, isSubmitting }): React.ReactNode => (
        <Form>
          {touched.message && errors.message && (
            <p className={`form_template_area_block--error ${classes.errorMessage}`}>{errors.message}</p>
          )}
          <div className="mypage_content_message_chat_field">
            <Field name={"message"}>
              {({ field }: FieldProps<string>): React.ReactNode => (
                <div className="mypage_content_message_chat_field_input">
                  <div className="mypage_content_message_chat_field_input_bg" />
                  <textarea placeholder={"メッセージを入力する…"} {...field} />
                </div>
              )}
            </Field>
            <div className="mypage_content_message_chat_field_submit">
              <div className="mypage_content_message_chat_field_submit_bg" />
              <Input disabled={isSubmitting} value="メッセージを送信" type="submit" />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

type PostOrderMessageFields = Omit<PostOrderMessageQuery, "order_message_thread_id">

const useStyles = makeStyles((theme) => ({
  errorMessage: {
    marginBottom: "5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
  },
}));
const Input = styled.input`
  color: black;
`;
